import { useState, useEffect } from 'react';
import { getTips } from 'common/api/tip';
import { Tip } from '../types';

const TIP_LOCAL_STORAGE_KEY = 'tipsPopup';

interface UseTipsReturn {
  tip: Tip | undefined;
  showModal: boolean;
  handleCloseModal: () => void;
}

const useTips = (): UseTipsReturn => {
  const [tips, setTips] = useState<Tip[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const today = new Date().toISOString().slice(0, 10);

  // Fetch tips on mount
  useEffect(() => {
    const fetchTips = async () => {
      try {
        const response = await getTips();
        setTips(response);
      } catch (err) {
        console.error('Error fetching tips:', err);
      }
    };

    fetchTips();
  }, []);

  // Check localStorage to determine if modal should show
  useEffect(() => {
    const lastModalDate = localStorage.getItem(TIP_LOCAL_STORAGE_KEY);
    if (!lastModalDate) {
      setShowModal(true);
      return;
    }
    if (today !== lastModalDate) {
      setShowModal(true);
    }
  }, [today]);

  const handleCloseModal = () => {
    localStorage.setItem(TIP_LOCAL_STORAGE_KEY, today);
    setShowModal(false);
  };

  return { tip: tips[0], showModal, handleCloseModal };
};

export default useTips;
